export const ACCOUNT_ENDPOINTS = {
  ACCOUNT_SUMMARY: (customerId: string) => `/accounts/customer/${customerId}`,
  RECENT_TRANSACTIONS: (accountNumber: string) => `/accounts/${accountNumber}/recent-transactions`,
  // MONTHLY_SPEND: '/account/spending/monthly',
  DEPOSIT_SLIP: '/deposit-slip',
  LOGOUT: '/auth/logout',
  PROFILE: '/users/me',
  PROFILE_PHOTO: '/users/me/photo',
} as const;
